<template>
    <v-dialog v-model="isNewFichajeVisible" max-width="600px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Nuevo fichaje
            </v-card-title>
            <v-card-text class="mt-3">
                <v-form ref="formFichaje" v-model="formFichajeValid">
                    <v-row>
                        <v-col cols="12" v-if="admin">
                            <v-autocomplete
                                hide-details
                                v-model="selectedFichaje.usuario_id"
                                :items="usuarios"
                                item-text="name"
                                item-value="id"
                                label="Usuarios"
                                outlined
                                dense
                                :rules="[rules.required]"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ordenesSelect
                                v-model="selectedFichaje.orden_id"
                                label="Obra"
                                outlined
                                dense
                                :extra="selectedFichaje.orden"
                                :rules="[rules.required]"
                            >
                            </ordenesSelect>
                        </v-col>

                        <v-col cols="12" md="6">
                            <date-select
                                label="Fecha"
                                v-model="selectedFichaje.fecha"
                                outlined
                                dense
                                :rules="[rules.required]"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                label="Hora inicio"
                                v-mask="`##:##`"
                                v-model="selectedFichaje.hora_inicio"
                                outlined
                                dense
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                label="Hora fin"
                                v-mask="`##:##`"
                                v-model="selectedFichaje.hora_fin"
                                outlined
                                dense
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn color="error" @click="isNewFichajeVisible = false">
                    Cancelar
                </v-btn>
                <v-btn color="success" @click="saveFichaje()">
                    Confirmar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
import dateSelect from "../../../components/general/dateSelect.vue";
import { rules } from "../../../rules";

export default {
    props: ["value", "users", "item"],
    components: { ordenesSelect, dateSelect },
    data() {
        return {
            rules: rules,
            rol: null,
            isNewFichajeVisible: false,
            selectedFichaje: {
                id: null,
                usuario_id: null,
                orden_id: null,
                fecha: "",
                hora_inicio: "",
                hora_fin: "",
            },
            formFichajeValid: true,
            menuHoraInicio: false,
            menuHoraFin: false,
            usuarios: [],
        };
    },
    created() {
        this.rol = localStorage.getItem("role");
        if (this.item != null) {
            this.selectedFichaje = this.item;
        }
    },
    mounted() {
        if (!this.users || this.users.length == 0) {
            this.getUsuarios();
        } else {
            this.usuarios = this.users;
        }
    },
    methods: {
        async saveFichaje() {
            try {
                this.$refs.formFichaje.validate();
                if (!this.formFichajeValid) {
                    return;
                }

                let res = null;
                if (this.selectedFichaje.id != null) {
                    res = await axios.put(
                        `api/orden/fichaje/${this.selectedFichaje.id}`,
                        this.selectedFichaje
                    );
                } else {
                    res = await axios.post(
                        "api/orden/fichaje",
                        this.selectedFichaje
                    );
                }

                this.$toast.sucs(res.data.message);
                this.isNewFichajeVisible = false;
                this.$emit("refresh");
                this.clearForm();
            } catch (err) {
                this.$toast.error(err.response.data.message);
            }
        },
        async getUsuarios() {
            try {
                const res = await axios.get(`api/get-empleados-token-fichaje`);
                const response = res.data.data;
                // response.unshift("");
                this.usuarios = response;
            } catch (err) {
                this.$toast.error("Error consultando los usuarios");
            }
        },

        clearForm() {
            this.selectedFichaje = {
                id: null,
                usuario_id: null,
                orden_id: null,
                fecha: "",
                hora_inicio: "",
                hora_fin: "",
            };
        },
    },
    watch: {
        value: {
            handler(newVal) {
                this.isNewFichajeVisible = newVal;
            },
            immediate: true,
        },
        isNewFichajeVisible: {
            handler(newVal) {
                this.$emit("input", newVal);
            },
            immediate: true,
        },
        item: {
            handler(newVal) {
                if (newVal != null && newVal != undefined) {
                    this.selectedFichaje = newVal;
                }
            },
            immediate: true,
        },
    },
    computed: {
        admin() {
            return this.rol == 1 || this.rol == 2 || this.rol == 9;
        },
    },
};
</script>
